<template>
  <div v-if="instrument_id" class="animated fadeIn">
    <b-tabs card>
      <b-tab title="Analyses" active>
        <h3>Analyses</h3>
        <permission-alert-gate :permissions="'list analysis'">
          <template #gated-content>
            <analysis-server-table
              :show_columns="[
                'name',
                'modus_name',
                'extraction_method',
                'measurement_method',
              ]"
            />
          </template>
        </permission-alert-gate>
      </b-tab>
      <b-tab title="Jigs" active>
        <h3>
          Jigs
          <b-button
            v-if="add_permission_check"
            :to="`/instrument/${instrument_id}/instrument-jig/add`"
            variant="success"
            class="float-right"
          >
            <i class="fal fa-plus" />
          </b-button>
        </h3>
        <permission-alert-gate :permissions="'list instrument jig'">
          <template #gated-content>
            <instrument-jig-server-table
              :show_columns="[
                'jig.name',
                'jig.x',
                'jig.y',
                'jig.z',
                'jig.capacity',
              ]"
            />
          </template>
        </permission-alert-gate>
      </b-tab>
      <b-tab title="Instances" active>
        <h3>Instances</h3>
        <permission-alert-gate :permissions="'list instrument instance'">
          <template #gated-content>
            <instrument-instance-server-table
              :filter_display="filter_display"
              :show_columns="[
                'equipment_number',
                'identifier',
                'name',
                'instrument.name',
                'priority',
                'location',
              ]"
            />
          </template>
        </permission-alert-gate>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AnalysisServerTable from "@/components/lab/analysis/AnalysisServerTable";
import InstrumentJigServerTable from "@/components/lab/instrumentjig/InstrumentJigServerTable";
import InstrumentInstanceServerTable from "@/components/lab/instrumentinstance/InstrumentInstanceServerTable";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { AccessControlCheck } from "@/auth/AccessControlCheck";

export default {
  name: "InstrumentDetailCardstack",
  components: {
    AnalysisServerTable,
    InstrumentJigServerTable,
    InstrumentInstanceServerTable,
    PermissionAlertGate,
  },
  data() {
    return {
      instrument_id: this.$route.params.instrument_id || null,
      filter_display: {
        show_type_filter: false,
        show_sample_type_filter: true,
        show_analyte_filter: true,
      },
    };
  },
  computed: {
    add_permission_check() {
      return AccessControlCheck.checkPermission("add instrument jig");
    },
  },
};
</script>
